import { z } from 'zod';
import { NumberFormatting, Validation } from '@mews/framework';

export enum AverageNightRateFormKeys {
    value = 'value',
    currency = 'currency',
    reason = 'reason',
}

export const averageNightRateFormSchema = (numberLocalizationInfo: NumberFormatting) => {
    return z.object({
        [AverageNightRateFormKeys.value]: Validation.Number.LocalizedCurrencyNumber(numberLocalizationInfo).pipe(
            z
                .number()
                .min(0)
                .transform((val) => val.toString())
        ),
        [AverageNightRateFormKeys.currency]: Validation.String.Required,
        [AverageNightRateFormKeys.reason]: Validation.String.Required,
    });
};

export type AverageNightRateFormValues = z.infer<ReturnType<typeof averageNightRateFormSchema>>;
